import { render, staticRenderFns } from "./tbm.vue?vue&type=template&id=3fc0b497"
import script from "./tbm.vue?vue&type=script&lang=js"
export * from "./tbm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fc0b497')) {
      api.createRecord('3fc0b497', component.options)
    } else {
      api.reload('3fc0b497', component.options)
    }
    module.hot.accept("./tbm.vue?vue&type=template&id=3fc0b497", function () {
      api.rerender('3fc0b497', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/demo/tbm.vue"
export default component.exports